import Model, { belongsTo, attr } from '@ember-data/model';

export default Model.extend({
  individual: belongsTo('coaching/individual', { async: false, inverse: null }),
  startDate: attr('date-only'),
  endDate: attr('date-only'),
  sectionFieldValues: attr(),
  completed: attr('boolean'),
  coachNotes: attr('string'),
  feedback: attr('string'),
});
